import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  text: {
    id: 'LumaBot.LumaBotFlowSessionLog.LumaBotFlowSessionLogErrorState.text',
    defaultMessage: 'We encountered an error. Please, try again.',
  },
});
